<template lang="html">
   <UiModal :active="false"
        v-if="$store.state.specialist.modals.buyService"
        @close="$store.state.specialist.modals.buyService = false"
        title="Finalizare achizitie"
        subtitle="Plata cu credite"
        :buttons="buttons"
        @submit="buy('service')">

        <template slot="body">
            <div class="buy">
                <div class="buy__title">
                    Ești sigur că dorești să achiziționezi acest serviciu?
                </div>

                <div class="service">
                    <div class="service__title">
                        Sedintă standard
                    </div>

                    <div class="service__divider"></div>
                    
                    <div class="service__details">
                        <div class="details__left">
                            <div class="details__left--price">
                                {{specialist.service_price}}
                                <img src="@/assets/images/icons/coins.svg" alt="">
                            </div>
                            <div class="details__left--time">{{meta.standard_service_duration}} minute</div>
                        </div>

                        <div class="details__right">
                            <img src="@/assets/images/icons/address-card.svg" class="details__right--icon" />
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </UiModal>

    <UiModal :active="false"
        v-else-if="$store.state.specialist.modals.buyPackage"
        @close="$store.state.specialist.modals.buyPackage = false"
        title="Finalizare achizitie"
        subtitle="Plata cu credite"
        :buttons="buttons"
        @submit="buy('package')">

        <template slot="body" v-if="pack">
            <div class="buy">
                <div class="buy__title">
                    Esti sigur că dorești să achizitionezi acest pachet?
                </div>

                <div class="package">
                    <div class="package__head">
                        <div class="package__name">
                            <span>{{ pack.name }}</span>
                        </div>
                    </div>
                    <div class="package__body">
                        <div class="package__price header-2">
                            {{ getPackagePrice(pack) }} 
                            <img src="@/assets/images/icons/coins.svg" alt="">
                        </div>
                        <div class="package__services header-4">
                            {{pack.services_number}} ședinte
                        </div>
                        <div class="package__description">
                            {{pack.description}}
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </UiModal>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import UiModal from '@/components/ui/Modal'

export default {
    components: {
        UiModal
    },
    props: {
        pack: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            buttons: [
                {
                    event: "submit",
                    text: "Cumpara"
                }
            ]
        };
    },
    computed: {
        ...mapGetters({
            specialist: 'specialist/specialist',
            meta: 'specialist/metadata'
        })
    },
    methods: {
        ...mapActions({
            buyService: 'specialist/buyService',
            buyPackage: 'specialist/buyPackage',
            billingDetailsModal: 'layout/billingDetailsModal'
        }),
        buy(type) {
            //I.Check for billing details
            if(localStorage.getItem('address') !== 'true'){
                this.billingDetailsModal(true);
                return;
            }

            //II.Check purchase type
            switch (type) {
                case 'service': {
                    let data  = {
                        specialist_id: this.$router.currentRoute.params.id,
                        number: 1
                    };
                    this.buyService(data);
                    break;
                }
                case 'package': {
                    let data  = {
                        specialist_id: this.$router.currentRoute.params.id,
                        package_id: this.pack.id
                    };
                    this.buyPackage(data);
                    break;
                }
            }
        },
        getPackagePrice(pack) {
            var total = pack.services_number*this.specialist.service_price;
            return total - (pack.discount/100)*total;
        }
    }
}
</script>

<style lang="scss" scoped>
    .buy {
        margin: 30px 0;
        
        &__title {
            font-family: 'DIN Pro', sans-serif;
            font-style: normal;
            font-weight: 500;
            font-size: 18px;
            line-height: 20px;
            text-align: center;
            color: $color-main-text;
        }

        &__buttons {
            width: 100%;
            display: flex;
            margin: 0;
            justify-content: space-between;
        }

        &__button-container {
            width: 50%;
            margin: 10px;
        }
        &__button {
            width: 100%;
            height: 35px;
            text-align: center;
            background: #C4C4C4;
            border-radius: 3px;
            color: $color-light;
            border: none;
            cursor: pointer;
            outline: none;
        }

        &__button-active {
            background: $color-primary;
            border-radius: 3px;
        }
    }

    .service {
        border: 1px solid rgba($color-main-text, 0.25);
        box-sizing: border-box;
        box-shadow: 0px 0px 20px rgba($color-main-text, 0.06);
        min-width: 100px;
        max-width: 200px;
        padding: 10px;
        margin: 30px auto;

        &__title {
            font-family: 'DIN Pro', sans-serif;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 20px;
            display: flex;
            align-items: center;
            color: #373435;
        }

        &__divider {
            height: 1px;
            width: 100%;
            margin: 10px 0;
            background: rgba($color-gray, 0.25);
        }

        &__details {
            display: flex;
        }

        .details {

            &__left {
                width: 50%;
                
                &--price {
                    font-family: 'Roboto', sans-serif;
                    font-style: normal;
                    font-weight: 500;
                    font-size: 24px;
                    line-height: 30px;
                    text-align: left;
                    color: $color-warning;
                }

                &--time {
                    font-family: 'Roboto', sans-serif;
                    font-style: normal;
                    font-weight: 500;
                    font-size: 18px;
                    line-height: 30px;
                    color: rgba($color-gray, 0.7);
                }
            }

            &__right {
                width: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                
                &--icon {
                    margin: auto;
                }
            }           
        }
    }

    .package {
        background-color: $color-primary;
        box-sizing: border-box;
        box-shadow: 0px 0px 20px #0000000F;
        color: white;
        min-width: 215px;
        max-width: 215px;
        padding: 20px;
        margin: 30px auto;

        &--last {
            margin: 0px;
        }

        &__head {
            border-bottom: 2px solid white;
        }

        &__name {
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 15px;

            span{
                font-family: DIN Pro;
                font-style: normal;
                font-weight: bold;
                font-size: 16px;
                line-height: 20px;
                text-align: center;
            }
        }

        &__price {
            color: $color-warning;
            margin-top: 25px;
            font-weight: 500;
            line-height: 21px;
        }

        &__services {
            margin-top: 10px;
        }

        &__description {
            font-family: 'DIN Pro', sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 20px;
            color: #FFFFFF;
            margin-top: 20px;
        }

        &__button {
            border-radius: 17.5px;
            border: none;
            cursor: pointer;
            color: $color-primary;
            font-family: 'DIN Pro', sans-serif;
            font-size: 14px;
            font-weight: 500;
            height: 35px;
            margin: 25px auto 15px auto;
            outline: none;
            transition: all 0.2s ease;
            width: 100%;

            &:hover {
                background-color: $color-primary;
                border: 2px solid white;
                color: white;
            }
        }

        &__discount {
            text-align: center;
            font-size: 14px;
            opacity: .6;
        }
    }
</style>